<template>
  <label v-if="languages.length > 1" class="ui-language-switcher">
    <span>{{ $t("common.language") }}</span>
    <select :value="locale" :disabled="saving" @change="change">
      <option v-for="item in languages" :key="item.code" :value="item.code">{{ item.name }}</option>
    </select>
    <span v-if="failed" role="alert">{{ $t("common.syncFailed") }}</span>
  </label>
</template>
<script setup>
import { ref } from "vue";
import axios from "axios";
import { useI18n } from "vue-i18n";
import { languages, setUiLanguage } from "@/i18n";
import { useUserStore } from "@/store/modules/user";
const { locale } = useI18n();
const saving = ref(false);
const failed = ref(false);
const userStore = useUserStore();
async function change(event) {
  const code = event.target.value;
  setUiLanguage(code);
  saving.value = true;
  failed.value = false;
  try {
    if (userStore.isLoggedIn) {
      await axios.put(`${process.env.VUE_APP_API_URL}/api/v1/locale`, { language_code: code });
      userStore.update({ ...userStore.user, language_code: code });
    }
  } catch {
    failed.value = true;
  } finally { saving.value = false; }
}
</script>
<style scoped>
.ui-language-switcher { display: inline-flex; align-items: center; gap: .5rem; padding: .4rem; font-size: .8rem; }
select { color: inherit; background: transparent; border: 1px solid currentColor; border-radius: 5px; padding: .3rem; }
[role="alert"] { max-width: 18rem; }
</style>
